import React from 'react';

import HandDrawnArrow from '~Assets/icons/hand-drawn-arrow.svg';
import ImprovedButton from '~ComponentsImproved/Button';
import Icon from '~ComponentsImproved/Icon';
import { useI18n } from '~Hooks';
import { Box, Column, Columns } from '~Styles';

import {
  ActionsHeading,
  ActionsHeadingBold,
  ActionsWrapper,
  InfoHeading,
  InfoParagraph,
  SearchHeading,
  SearchParagraph,
  SearchWrapper,
  Wrapper,
} from './styles';

export default function LandingPage({
  setCreateModalOpen,
  scanExistingCard,
}: {
  setCreateModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  scanExistingCard: () => void;
}) {
  const { i18n } = useI18n();
  return (
    <Wrapper padding="xl">
      <Box display="flex" alignItems="center" style={{ margin: '80px 0 130px' }}>
        <Icon
          src={HandDrawnArrow}
          color="#666"
          width="80px"
          height="80px"
          style={{ transform: 'rotate(170deg)' }}
        />
        <SearchWrapper>
          <SearchHeading>{i18n('GC.Landing.SearchHeading')}</SearchHeading>
          <SearchParagraph>{i18n('GC.Landing.SearchText')}</SearchParagraph>
        </SearchWrapper>
      </Box>
      <ActionsWrapper boxShadow="hard">
        <ActionsHeading>
          <ActionsHeadingBold>{i18n('GC.Landing.Sell')}</ActionsHeadingBold>{' '}
          {i18n('GC.Landing.Or')}{' '}
          <ActionsHeadingBold>{i18n('GC.Landing.TopUp')}</ActionsHeadingBold>{' '}
          {i18n('GC.Landing.AGiftCard')}
        </ActionsHeading>
        <Columns>
          <Column style={{ paddingRight: '16px' }}>
            <InfoHeading>{i18n('GC.Landing.PhysicalCard')}</InfoHeading>
            <InfoParagraph>{i18n('GC.Landing.PhysicalCardText')}</InfoParagraph>
            <ImprovedButton
              onTouchStart={scanExistingCard}
              text={i18n('GC.Landing.ScanCard')}
              styleType="OK"
            />
          </Column>
          <Column style={{ paddingLeft: '16px' }}>
            <InfoHeading>{i18n('GC.Landing.DigitalCard')}</InfoHeading>
            <InfoParagraph>{i18n('GC.Landing.DigitalCardText')}</InfoParagraph>
            <ImprovedButton
              onTouchStart={() => setCreateModalOpen(true)}
              text={i18n('GC.Landing.SellDigitalCard')}
              styleType="OK"
            />
          </Column>
        </Columns>
      </ActionsWrapper>
    </Wrapper>
  );
}
